import { render, staticRenderFns } from "./PulsatingRedDot.vue?vue&type=template&id=42e5acb8&scoped=true"
import script from "./PulsatingRedDot.vue?vue&type=script&lang=js"
export * from "./PulsatingRedDot.vue?vue&type=script&lang=js"
import style0 from "./PulsatingRedDot.vue?vue&type=style&index=0&id=42e5acb8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42e5acb8",
  null
  
)

export default component.exports